<template>
  <div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="开始时间">
                <el-date-picker
                  v-model="searchForm.startTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束时间">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="search-button">
              <el-button type="primary" @click="handleSearch">点击查询</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">专项工作账单列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div style="display: flex; align-items: center; margin-bottom: 20px; font-size: 14px">
          <span style="font-weight: bold; margin-right: 8px">专项工作总计（人次）：</span>
          <span style="color: #333">{{ totalWorkManpower }}</span>
        </div>
        <el-table
          :data="tableData"
          border
          stripe
          @selection-change="handleSelectionChange"
          ref="table"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="region" label="区域-地区"></el-table-column>
          <el-table-column prop="charge_type" label="计费类型"></el-table-column>
          <el-table-column prop="charge_subType1" label="计费小类1"></el-table-column>
          <el-table-column prop="charge_subType2" label="计费小类2"></el-table-column>
          <el-table-column label="计费单位" :formatter="() => '人次'"></el-table-column>
          <el-table-column prop="real_num" label="计费数量"></el-table-column>
          <el-table-column prop="start_time" label="开始时间"></el-table-column>
          <el-table-column prop="end_time" label="结束时间"></el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getBillSpecialWork } from '@/api/billApi';

export default {
  name: 'SpecialWork',
  data() {
    return {
      debouncedExport: null,
      exportLoading: false,
      searchForm: {
        startTime: '',
        endTime: '',
      },
      allTableData: [], // 存储所有数据
      tableData: [], // 当前页显示的数据
      currentPage: 1,
      pageSize: 10,
      totalWorkManpower: 0,
      total: 0,
      loading: false,
      selectedRows: [],
      headers: {
        region: '区域-地区',
        charge_type: '计费类型',
        charge_subType1: '计费小类1',
        charge_subType2: '计费小类2',
        unit: '计费单位',
        real_num: '计费数量',
        start_time: '开始时间',
        end_time: '结束时间',
      },
    };
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  created() {
    // 获取当前月份的第一天和最后一天
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    
    // 设置默认的时间范围
    this.searchForm.startTime = this.$moment(firstDay).format('YYYY-MM-DD');
    this.searchForm.endTime = this.$moment(lastDay).format('YYYY-MM-DD');
    
    this.fetchTableData();
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    async fetchTableData() {
      this.loading = true;
      try {
        const params = {
          export_excel: 0,
        };

        if (this.searchForm.startTime) {
          params.start_time = this.searchForm.startTime;
        }
        if (this.searchForm.endTime) {
          params.end_time = this.searchForm.endTime + ' 23:59:59';
        }

        const response = await getBillSpecialWork(params);
        // 处理时间格式
        const formattedData = (response.data.data.list || []).map((item) => ({
          ...item,
          start_time: item.start_time ? item.start_time.split('T')[0] : '-',
          end_time: item.end_time ? item.end_time.split('T')[0] : '-',
        }));
        this.allTableData = formattedData;
        this.total = formattedData.length;
        this.totalWorkManpower = response.data.data.all_num || 0;
        this.updatePageData(); // 更新当前页数据
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    handleReset() {
      this.searchForm = {
        startTime: '',
        endTime: '',
      };
      this.currentPage = 1;
      this.fetchTableData();
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await getBillSpecialWork({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
            export_excel: 1
          });

          if (response.data) {
            let headers = this.headers;
            this.loading = false;
            const allData = response.data.data.list || [];
            // 使用后端返回的all_num值作为专项工作总计
            const totalWorkManpower = response.data.data.all_num || 0;

            // 创建工作表数据
            const worksheetData = [];

            // 第一行放置专项工作总计信息
            worksheetData.push({ '专项工作总计（人次）': totalWorkManpower });

            // 添加表头作为第二行
            const headerRow = {};
            Object.values(headers).forEach((label) => {
              headerRow[label] = label;
            });
            worksheetData.push(headerRow);

            // 添加表格数据
            allData.forEach((row) => {
              const rowData = {};
              Object.keys(headers).forEach((key) => {
                rowData[headers[key]] = row[key] || '-';
              });
              worksheetData.push(rowData);
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData, { skipHeader: true });

            // 设置更合理的列宽
            const colWidths = [];

            // 为专项工作总计设置更宽的宽度以确保完整显示
            colWidths.push({ wch: 30 });

            // 为其他列设置宽度
            Object.values(headers).forEach((header) => {
              if (header.includes('时间')) {
                colWidths.push({ wch: 20 }); // 时间字段宽一些
              } else if (header.includes('区域') || header.includes('类型')) {
                colWidths.push({ wch: 18 }); // 文本字段适中
              } else {
                colWidths.push({ wch: 15 }); // 其他字段默认宽度
              }
            });

            worksheet['!cols'] = colWidths;

            // 设置第一行的合并单元格
            worksheet['!merges'] = [
              { s: { r: 0, c: 0 }, e: { r: 0, c: Object.keys(headers).length - 1 } },
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '专项工作账单列表');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `专项工作账单列表_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          let headers = this.headers;
          // 导出选中数据
          const totalWorkManpower = this.selectedRows.reduce(
            (sum, item) => sum + (item.amount || 0),
            0
          );

          // 创建工作表数据
          const worksheetData = [];

          // 第一行放置专项工作总计信息
          worksheetData.push({
            '专项工作总计（人次）': '专项工作总计（人次）：' + totalWorkManpower,
          });

          // 添加表头作为第二行
          const headerRow = {};
          Object.values(headers).forEach((label) => {
            headerRow[label] = label;
          });
          worksheetData.push(headerRow);

          // 添加表格数据
          this.selectedRows.forEach((row) => {
            const rowData = {};
            Object.keys(headers).forEach((key) => {
              if (key === 'unit') {
                rowData[headers[key]] = '人次';
              } else {
                rowData[headers[key]] = row[key] || '-';
              }
            });
            worksheetData.push(rowData);
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData, { skipHeader: true });

          // 设置更合理的列宽
          const colWidths = [];

          // 为专项工作总计设置更宽的宽度以确保完整显示
          colWidths.push({ wch: 30 });

          // 为其他列设置宽度
          Object.values(headers).forEach((header) => {
            if (header.includes('时间')) {
              colWidths.push({ wch: 20 }); // 时间字段宽一些
            } else if (header.includes('区域') || header.includes('类型')) {
              colWidths.push({ wch: 18 }); // 文本字段适中
            } else {
              colWidths.push({ wch: 15 }); // 其他字段默认宽度
            }
          });

          worksheet['!cols'] = colWidths;

          // 设置第一行的合并单元格
          worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: Object.keys(headers).length - 1 } },
          ];

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '专项工作账单列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `专项工作账单列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.updatePageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updatePageData();
    },
    updatePageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.tableData = this.allTableData.slice(start, end);
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
  },
};
</script>

<style scoped>
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
.search-form {
  width: 100%;
}
.search-button {
  display: flex;
  justify-content: flex-end;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>